import { useState } from 'react';
import { connect } from 'react-redux';
import { deliverOrder } from 'actions/orderDelivery';
import { resetOrder } from 'actions/orderSearch';

let _content = null;

const OrderDeliveryComplete = (props) => {
  const { resetOrder, deliverOrder, currentStaff, order } = props;

  let requestBodyAll = {};

  const [redirect, setRedirect] = useState(false);
  const [successModal, setSuccessModal] = useState(true);

  const deliverOrderData = () => {
    requestBodyAll['staff_remote_id'] = currentStaff.remote_id;
    requestBodyAll['retail_store_remote_id'] =
      currentStaff.current_store.remote_id;
    deliverOrder(order.pk, requestBodyAll);
  };

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const closeModal = () => {
    setSuccessModal({});
    setRedirect(true);
  };

  const printPage = () => {
    window.print();
  };

  return (
    _content &&
    _content({
      props,
      redirect,
      requestBodyAll,
      successModal,
      deliverOrderData,
      cleanStateAndRedirect,
      closeModal,
      printPage,
    })
  );
};

const mapDispatchToProps = {
  deliverOrder,
  resetOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderSearch.order,
  error: state.orderDelivery.error,
  pending: state.orderDelivery.pending,
  currentStaff: state.staffs.currentStaff,
  success: state.orderDelivery.success,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderDeliveryComplete);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/deliveryComplete/index.js